// Static fixtures for the Design-section demos. No API, no stores - the
// canonical layouts render identically anywhere and never depend on server state.

export type DemoScope = 'Everyone' | 'Department' | 'Personal'

export interface DemoProject {
  id: string
  name: string
  owner: string
  status: 'Active' | 'Paused' | 'Archived'
  members: number
  updated: string
  scope: DemoScope
}

export const demoProjects: DemoProject[] = [
  { id: 'p1', name: 'Onboarding Revamp', owner: 'Anna K.', status: 'Active', members: 8, updated: '2h ago', scope: 'Everyone' },
  { id: 'p2', name: 'Q3 Roadmap', owner: 'Dmitry C.', status: 'Active', members: 5, updated: '1d ago', scope: 'Everyone' },
  { id: 'p3', name: 'Brand Guidelines', owner: 'Maria P.', status: 'Paused', members: 3, updated: '4d ago', scope: 'Everyone' },
  { id: 'p4', name: 'Sales Playbook', owner: 'Igor S.', status: 'Active', members: 6, updated: '3h ago', scope: 'Department' },
  { id: 'p5', name: 'Support Macros', owner: 'Lena V.', status: 'Active', members: 4, updated: '6h ago', scope: 'Department' },
  { id: 'p6', name: 'Personal Notes', owner: 'You', status: 'Active', members: 1, updated: 'just now', scope: 'Personal' },
  { id: 'p7', name: 'Scratchpad', owner: 'You', status: 'Archived', members: 1, updated: '2w ago', scope: 'Personal' },
]

export interface DemoMail {
  id: string
  from: string
  subject: string
  preview: string
  time: string
  unread: boolean
  body: string
}

// `preview` feeds the 3-rail list rows; `body` feeds the detail pane (see ThreeRailDemo).
export const demoInbox: DemoMail[] = [
  { id: 'm1', from: 'Anna Kuznetsova', subject: 'Design kit review', preview: 'Could you take a look at the two-rail...', time: '09:24', unread: true, body: 'Could you take a look at the two-rail layout before standup? I want to make sure the brow height lines up with the rail header.' },
  { id: 'm2', from: 'GitLab', subject: 'Pipeline #34211 passed', preview: 'os-core - main - 12 jobs passed...', time: '08:57', unread: true, body: 'Pipeline #34211 passed for os-core on branch main. 12 jobs succeeded.' },
  { id: 'm3', from: 'Maria Petrova', subject: 'Re: Brand colours', preview: 'The tokens look right in dark mode now...', time: 'Yesterday', unread: false, body: 'The tokens look right in dark mode now. Thanks for the fix - let us ship it.' },
  { id: 'm4', from: 'Igor Sokolov', subject: 'Sales deck v3', preview: 'Attached the latest deck for the...', time: 'Yesterday', unread: false, body: 'Attached the latest deck for the enterprise pitch. Slides 4-7 are new.' },
  { id: 'm5', from: 'Lena Volkova', subject: 'Support rota', preview: 'Here is next weeks on-call rotation...', time: 'Mon', unread: false, body: 'Here is next weeks on-call rotation. Shout if any of the slots clash with your calendar.' },
]

export interface DemoKpi {
  label: string
  value: number
  accent: string
}

// accent values are raw Tailwind category hues (not theme tokens): KpiCard's
// contract takes a text-color utility class for these multi-hued KPI accents.
export const demoKpis: DemoKpi[] = [
  { label: 'Projects', value: 24, accent: 'text-blue-500' },
  { label: 'Active', value: 17, accent: 'text-emerald-500' },
  { label: 'Members', value: 58, accent: 'text-violet-500' },
  { label: 'Archived', value: 7, accent: 'text-amber-500' },
]
